import { useNavigate } from "react-router-dom";
import { auth } from "services";

const Menu = () => {
  let navigate = useNavigate();

  const logout = () => {
    auth.logout();
    location.replace("/login");
  };

  const gotopage = (page) => {
    navigate(page);
  };

  return (
    <ul className="list-unstyled text-dark">
      <li className="my-3">
        <button
          className="fs-4 btn btn-outline-app w-100 text-start mb-1 py-3"
          onClick={() => gotopage("/profile")}
          data-bs-dismiss="offcanvas"
        >
          <i className="bi bi-person-circle pe-1"></i> Profile
        </button>
      </li>
      <li className="my-3 d-block d-md-none">
        <button
          className="fs-4 btn btn-outline-app w-100 text-start mb-1 py-3"
          onClick={() => gotopage("/reports")}
          data-bs-dismiss="offcanvas"
        >
          <i className="bi bi-bar-chart-line-fill pe-1"></i> Reports
        </button>
      </li>
      <li className="my-3">
        <div className="accordion" id="menuAccordion">
          <div className="accordion-item border-danger">
            <h2 className="accordion-header" id="headingCalc">
              <button
                className="accordion-button text-danger collapsed fs-4 px-3 py-3"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseCalc"
              >
                <i className="bi bi-calculator pe-2"></i> Calculators
              </button>
            </h2>

            <div
              id="collapseCalc"
              className="accordion-collapse collapse"
              data-bs-parent="#menuAccordion"
            >
              <div className="accordion-body p-0">

                <a
                  href="https://www.bahikhata.org/tools/emi-calculator-with-calendar"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn w-100 text-start py-2 px-4"
                >
                  EMI Calculator with Calendar
                </a>
                <a
                  href="https://www.bahikhata.org/tools/interest-calculator"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn w-100 text-start py-2 px-4"
                >
                  Interest Calculator
                </a>
                <a
                  href="https://www.bahikhata.org/tools/flat-vs-reducing-rate-calculator"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn w-100 text-start py-2 px-4"
                >
                  Flat vs Reducing
                </a>

                <a
                  href="https://www.bahikhata.org/tools/gold-loan"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn w-100 text-start py-2 px-4"
                >
                  Gold Loan
                </a>

              </div>
            </div>
          </div>
        </div>
      </li>
      <li className="my-3 disabled opacity-50 d-block d-md-none">
        <button
          className="fs-4 btn btn-outline-app w-100 text-start mb-1 py-3"
          onClick={() => gotopage("/passbook")}
          data-bs-dismiss="offcanvas"
          disabled
        >
          <i className="bi bi-bank pe-1"></i> Passbook
        </button>
      </li>
      <li className="my-3">
        <button
          className="fs-4 btn btn-outline-app w-100 text-start mb-1 py-3"
          onClick={() => gotopage("/settings")}
          data-bs-dismiss="offcanvas"
        >
          <i className="bi bi-gear pe-1"></i> Settings
        </button>
      </li>
      <li className="my-3">
        <button
          className="fs-4 btn btn-outline-app w-100 text-start mb-1 py-3"
          onClick={() => gotopage("/help")}
          data-bs-dismiss="offcanvas"
        >
          <i className="bi bi-info-circle-fill pe-1"></i> Help & Support
        </button>
      </li>
      <li className="my-3 mx-1">
        <button
          className="fs-5 btn btn-app w-100 text-start py-3"
          onClick={logout}
          data-bs-dismiss="offcanvas">
          <i className="bi bi-arrow-left pe-1"></i>
          <span className="fs-3 ms-2">Logout</span>
        </button>
      </li>
    </ul>
  );
};

export default Menu;